import {
    KBEntity,
    NoContentArticle,
    Tag,
    Types,
} from '../knowledge-base-common/knowledge-base-common.type';

export const isTag = (item: KBEntity): item is Tag => {
    return item?.type === Types.TAG;
};

export const isArticle = (item: KBEntity): item is NoContentArticle => {
    return item?.type === Types.ARTICLE;
};

export const getArticleLink = (articleId: string, clientUrl: string): string => {
    return `${clientUrl}?article=${articleId}`;
};
